import { render } from "./LbrxKioskSecondTheme.vue?vue&type=template&id=f141df5c&scoped=true"
import script from "./LbrxKioskSecondTheme.vue?vue&type=script&lang=js"
export * from "./LbrxKioskSecondTheme.vue?vue&type=script&lang=js"

import "./LbrxKioskSecondTheme.vue?vue&type=style&index=0&id=f141df5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f141df5c"]])

export default __exports__